export default {
  api_keys: "API密钥",
  api_docs: "文档",
  keys_count: "{current} / {total} 个密钥",
  unnamed: "未命名",
  edit_name: "编辑名称",
  upgrade_to_enable: "升级以启用API密钥功能",
  no_api_keys: "无API密钥",
  generate_key: "生成密钥",
  upgrade_to_generate: "升级以生成密钥",
  api_calls: "API调用",
  endpoint_stats: "端点调用统计",
  refresh: "刷新",
  free_plan_api_stats: "免费套餐用户无法查看API调用统计。请升级以查看详细数据。",
  data_updates: "数据每5分钟更新一次",
  api_call_logs: "API调用日志",
  api_call_logs_desc: "此处仅可查看使用有效API密钥的请求。数据每5分钟更新一次",
  select_api_key: "选择API密钥",
  endpoint: "端点",
  response_time: "响应时间",
  api_quota: "API配额",
  upgrade: "升级",
  current_plan: "当前套餐",
  key_count: "密钥数量",
  call_limit: "调用限制",
  no_access: "无访问权限",
  daily_limit: "每日 {limit} 次调用",
  total_limit: "总计限制 {limit} 次调用",
  monthly_limit: "每月 {limit} 次调用",
  calc_quota: "计算配额",
  calc_and_report_quota: "计算和报告配额",
  report_quota: "报告配额",
  daily_report_quota: "每日报告",
  extra_quota: "额外配额：{count} 次调用",
  edit_key_name: "编辑密钥名称",
  key_name: "密钥名称",
  key_name_placeholder: "请输入密钥名称",
  key_name_desc: "为您的API密钥起一个容易识别的名称",
  feature_restricted: "功能受限",
  feature_restricted_desc1: "您当前的套餐无法使用此功能",
  feature_restricted_desc2: "免费套餐用户无法使用API密钥相关功能。请升级到付费套餐以解锁完整功能。",
  upgrade_benefits: "升级套餐优势：",
  benefit1: "生成和管理API密钥",
  benefit2: "查看API调用统计和趋势",
  benefit3: "复制和使用API密钥",
  benefit4: "更高的计算和报告配额",
  benefit5: "更多高级功能",
  response_data_details: "响应数据详情",
  call_count: "{count} 次调用",
  name_required: "名称不能为空",
  name_too_long: "名称长度不得超过20个字符",
  key_generated: "密钥生成成功",
  key_deleted: "删除成功",
  key_updated: "名称更新成功",
  upgrade_required: "请升级",
  loading_docs: "正在加载API文档...",
  docs_load_error: "文档加载错误",
  docs_load_error_desc: "加载API文档时出错。请重试。",
  close_window: "关闭窗口",
  delete_confirm: "确认删除？",
  today: "今天",
  this_month: "本月",
  usage: "使用情况",
  plan_quota: "套餐配额：{count} 次调用",
  name: "名称",
  api_key: "API密钥",
  created_at: "创建时间",
  action: "操作",
  response_status: "状态码",
  response_data: "响应数据",
  call_count_name: "调用次数",
  update_failed: "更新失败",
  restricted: "受限",
};
